import {_, lockr, React, Redirect, Route, RouteComponentProps, Switch, uiConstants, withRouter} from '@api'
import {DashboardComponent, StoresInstanceContext} from '@design-board/components'
import {DashboardQueryParams, nav, globalStores as stores, Stores, globalStores, site} from '@stores'
import {differenceInObject, authStore} from '@utils'
import {autorun, computed, observable, runInAction} from 'mobx'
import {disposeOnUnmount} from 'mobx-react'
import {utils} from '@modules'
import {observer} from 'mobx-react'

interface MyProps {
}

@(withRouter as any)
@observer
export class Dashboard extends React.Component<MyProps> {
  constructor(props : MyProps) {
    super(props)

    globalStores.catalog.componentStores.dashboard = this
  }

  get catalog() { return stores.catalog}

  @observable.ref grid: any = React.createRef()

  componentWillUnmount(){
    nav.lastQueryParams = null
  }

  render() {
    if (!authStore.userIsAuthenticated) return null

    const {workspaces: {availableWorkspaces}, deployments: {selectedDeploymentId}} = globalStores,
      fallback = _.isEmpty(availableWorkspaces) ? <DashboardComponent gridRef={this.grid} /> : <Redirect to={`/${nav.slugForWorkspace(availableWorkspaces[0])}`}/>

    return (
      <Switch>
        <Route exact path={`/item-details`}>
          <DashboardComponent isDetailsRoute/>
        </Route>

        <Route exact path={`/vip`}>
          <DashboardComponent />
        </Route>

        {false && availableWorkspaces.map(ws =>
          <Route key={ws._id}
                 exact
                 path={`/${nav.slugForWorkspace(ws)}`}>
            {/*<StoresInstanceContext.Provider value={storesForWorkspace(workspaceFor(ws._id))}>*/}
              <DashboardComponent workspace={ws} />
            {/*</StoresInstanceContext.Provider>*/}
          </Route>)}

        <Route path='*'><Redirect to={`/vip${selectedDeploymentId ? `?deployment=${selectedDeploymentId}` : ''}`} /></Route>
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/containers/Dashboard.tsx